export default class SpriteMapPool {

    private availableSpriteMaps: Array<Map<string, PIXI.Sprite>> = [];
    private inUseSpriteMaps: Array<Map<string, PIXI.Sprite>> = [];

    public get() {
        const spriteMap = this.availableSpriteMaps.pop();

        if (!spriteMap) {
            return null;
        }

        this.inUseSpriteMaps.push(spriteMap);

        return spriteMap;
    }

    public release(spriteMap: Map<string, PIXI.Sprite>) {
        const index = this.inUseSpriteMaps.indexOf(spriteMap);
        if (index > -1) {
            this.inUseSpriteMaps.splice(index, 1);
        }

        this.cleanUp(spriteMap);

        this.availableSpriteMaps.push(spriteMap);
        spriteMap = null;
    }

    public add(spriteMap: Map<string, PIXI.Sprite>) {
        this.availableSpriteMaps.push(spriteMap);
    }

    public getSize() {
        return this.availableSpriteMaps.length + this.inUseSpriteMaps.length;
    }

    private cleanUp(spriteMap: Map<string, PIXI.Sprite>) {
        spriteMap.forEach((sprite) => sprite.visible = false);
    }
}
